"use strict";

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var browser_1 = __importDefault(require("./browser"));

var mobile_apps_1 = __importDefault(require("./mobile-apps"));

var feed_readers_1 = __importDefault(require("./feed-readers"));

var libraries_1 = __importDefault(require("./libraries"));

var media_players_1 = __importDefault(require("./media-players"));

var personal_information_managers_1 = __importDefault(require("./personal-information-managers"));

var clientParsers = [feed_readers_1.default, mobile_apps_1.default, media_players_1.default, personal_information_managers_1.default, browser_1.default, libraries_1.default];

var ClientParser = function ClientParser(options) {
  var _this = this;

  _classCallCheck(this, ClientParser);

  this.options = {
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var _iterator = _createForOfIteratorHelper(clientParsers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var Parser = _step.value;
        var parser = new Parser(_this.options);
        var client = parser.parse(userAgent);
        if (client.type !== "") return client;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
};

exports.default = ClientParser;